const ACCEPT_COOKIE_BOX = document.querySelector('.js-accept-cookie-box');
const ACCEPT_COOKIE_CHECK = localStorage.getItem('accept-cookie');
const acceptCookies = () => {
    localStorage.setItem('accept-cookie', '1');
    ACCEPT_COOKIE_BOX && ACCEPT_COOKIE_BOX.classList.remove('opened');
    document.body.classList.remove('accept-cookie-box-is-opened');
};
const rejectCookies = () => {
    ACCEPT_COOKIE_BOX && ACCEPT_COOKIE_BOX.classList.remove('opened');
    document.body.classList.remove('accept-cookie-box-is-opened');
};
const checkCookies = () => {
    if (!ACCEPT_COOKIE_CHECK || ACCEPT_COOKIE_CHECK !== '1') {
        ACCEPT_COOKIE_BOX && ACCEPT_COOKIE_BOX.classList.add('opened');
        document.body.classList.add('accept-cookie-box-is-opened');
    }
};
export { rejectCookies, acceptCookies, checkCookies };
